module.exports = __webpack_public_path__ + "img/3-3.b0dd3a20.png";